"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefTag = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefTag = exports.DefTag = function DefTag(_ref) {
  var label = _ref.label,
      index = _ref.index,
      removableTag = _ref.removableTag,
      onTagRemove = _ref.onTagRemove;
  return _react2.default.createElement(
    "div",
    { className: "Header__tag" },
    _react2.default.createElement(
      "div",
      { className: "Header__tag__label" },
      label
    ),
    removableTag && _react2.default.createElement(
      "div",
      { className: "Header__tag__close", onClick: function onClick(event) {
          return onTagRemove(index, event);
        } },
      "\u2715"
    )
  );
};